import { Image } from "hec/components/image";

import { sanitizeHtml } from "~/utils/sanitize-html";

import type { VideoImageTextProps } from "./types";
import { toYouTubeEmbed } from "./utils";

export const VideoImageText = ({
  videoUrl,
  blocks,
  sectionTitle,
  attributes,
}: VideoImageTextProps) => {
  const { className: extraClassName, ...restAttrs } = attributes ?? {};
  return (
    <section
      {...restAttrs}
      className={`w-full bg-neutral-100 px-4 py-10 lg:px-8 lg:py-16 ${extraClassName ?? ""}`}
    >
      <div className="mx-auto flex w-full max-w-[900px] flex-col gap-10 lg:gap-16">
        {sectionTitle ? (
          <h2 className="text-center text-2xl font-bold text-primary lg:text-3xl">
            {sectionTitle}
          </h2>
        ) : null}

        {videoUrl ? (
          <div className="mx-auto w-full max-w-[800px]">
            <div className="aspect-[16/9] w-full overflow-hidden">
              <iframe
                src={toYouTubeEmbed(videoUrl)}
                title="YouTube video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                className="h-full w-full border-0"
              />
            </div>
          </div>
        ) : null}

        {blocks?.length ? (
          <div className="flex flex-col gap-12 lg:gap-16">
            {blocks.map((block, idx) => (
              <div
                key={idx}
                className={`flex flex-col gap-6 lg:gap-10 ${
                  block.imagePosition === "right"
                    ? "lg:flex-row-reverse"
                    : "lg:flex-row"
                } lg:items-center`}
              >
                {block.imageUrl ? (
                  <div className="lg:w-1/2">
                    <Image
                      src={block.imageUrl}
                      alt={block.title ?? ""}
                      className="h-auto w-full object-cover"
                      maxCssWidth={450}
                      sizes="(min-width: 1024px) 450px, 100vw"
                    />
                  </div>
                ) : null}
                <div className="lg:w-1/2">
                  {block.title ? (
                    <h3 className="mb-4 text-xl font-bold text-primary lg:text-2xl">
                      {block.title}
                    </h3>
                  ) : null}
                  {block.description ? (
                    <div
                      className="text-base text-primary"
                      dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(block.description),
                      }}
                    />
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
};
